export default __webpack_public_path__ + "static/media/apple_chrome.ec666c57.svg";